import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function appReducer (state=initialState.app, action){
    switch(action.type) {
        case types.APP__GET_SYSTEM_INFORMATION_SUCCESS:
            return {...state, ...action.response };
        case types.PROFILE__GET_REQUEST: 
            return {...state, dimmer: 'Fetching Profile'};
        case types.POLICY__GET_REQUEST:
            return {...state, dimmer: 'Fetching Policies', retryPolicy: false};
        case types.POLICY__GET_FAILURE:
            return {...state, retryPolicy: true, dimmer: null};
        case types.PAYMENT__GET_WALLETS_REQUEST:
            return { ...state, dimmer: 'Fetching Wallet' };
        case types.PAYMENT__GET_WALLETS_FAILURE:
        case types.PAYMENT__GET_WALLETS_SUCCESS:
            return { ...state, dimmer: null };
        case types.PAYMENT__GET_SCHEDULED_PAYMENTS_REQUEST:
            return { ...state, dimmer: 'Fetching Scheduled Payments' };
        case types.PAYMENT__GET_SCHEDULED_PAYMENTS_FAILURE:
        case types.PAYMENT__GET_SCHEDULED_PAYMENTS_SUCCESS:
            return { ...state, dimmer: null };
        case types.CLAIM__REPORT_REQUEST:
            return { ...state, dimmer: 'Submitting Claim. This may take a few minutes.' };
        case types.CLAIM__REPORT_SUCCESS:
        case types.CLAIM__REPORT_FAILURE:
            return { ...state, dimmer: null };
        case types.POLICY__GET_SUCCESS:
        case types.PROFILE__GET_FAILURE:
        case types.PROFILE__GET_SUCCESS:
            return {...state, dimmer: null};
        default:
            return state;
    }
}
